import styled from "styled-components";

export const LegendContainer = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;

  display: flex;
  flex-direction: column;

  height: 21vh;
  width: 9vh;

  z-index: 1000;
  background: rgba(255, 255, 255, 0.8);
  padding: 10px;
  border-radius: 5px;
`;
